import React from "react";

export default function BusinessSizeBreakdownInfoHeader() {
  return (
    <thead role="rowgroup">
      <tr role="row">
        <th id="group2" role="columnheader" rowSpan="2">
          Business Size Designation
        </th>
        <th id="cat1" className="text-center" role="columnheader" colSpan="2">
          Category 1 (Group A)
        </th>
        <th id="cat2" className="text-center" role="columnheader" colSpan="2">
          Category 2 (Groups B-D)
        </th>
      </tr>
      <tr role="row">
        <th id="ch1" className="text-center" role="columnheader">
          Contract Holders
        </th>
        <th id="contract1" className="text-center" role="columnheader">
          Contracts
        </th>
        <th id="ch2" className="text-center" role="columnheader">
          Contract Holders
        </th>
        <th id="contract2" className="text-center" role="columnheader">
          Contracts
        </th>
      </tr>
    </thead>
  );
}
